<template>
  <v-dialog
    :value="value"
    @input="handleInput"
    max-width="500px"
    persistent
  >
    <avs-card>
      <template v-slot:title>
        <v-card-title class="pa-0"> {{ $t("commons.delete") }} {{ resource }} </v-card-title>
      </template>
      <template v-slot:content>
        <v-card-text>
          {{ $t("messages.information.delete.verification") }} {{ resource }} ?<br />
          <span v-if="!noPrevention">{{ $t("messages.information.delete.prevention") }}</span>
        </v-card-text>

        <v-card-actions class="d-flex justify-end gap-4">
          <avs-button
            color="blue white--text"
            iconI="mdi-check-circle-outline"
            noSpantext
            @click="handleDelete"
          >
            <template v-slot:name>{{ $t("commons.delete") }}</template>
          </avs-button>

          <avs-cancelButton @click="handleCancel" />
        </v-card-actions>
      </template>
    </avs-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteDialog",
  components: {},
  props: {
    noPrevention: {
      type: Boolean,
      default: false
    },
    resource: {
      type: String,
      default: "resource"
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleInput(newValue) {
      this.$emit("input", newValue)
    },
    handleCancel() {
      this.$emit("cancel")
    },
    handleDelete() {
      this.$emit("delete")
    }
  }
}
</script>
